// extracted by mini-css-extract-plugin
module.exports = {"table":"table--3krhQGPfi"};